import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./LandingPageSection6.module.css";

const LandingPageSection6 = () => {
  const navigate = useNavigate();

  const steps = [
    {
      num: "01",
      tag: "STEP 1",
      title: "Design your agent",
      desc: "Pick a role, upload your knowledge, set your voice."
    },
    {
      num: "02",
      tag: "STEP 2",
      title: "Connect your stack",
      desc: "Plug into CRM, calendar, and phone provider."
    },
    {
      num: "03",
      tag: "STEP 3",
      title: "Go live",
      desc: "Launch in minutes — scale to millions of calls."
    }
  ];

  return (
    <>
      {/* Integrations Section */}
      <section className={styles.integrationSection}>
        <div className={styles.container}>
          <h2 className={styles.integrationTitle}>
            Works with your <span className={styles.gradientText}>existing tools.</span>
          </h2>
          <p className={styles.integrationSubtitle}>
            Native integrations with the platforms your teams already love.
          </p>

          <div className={styles.orbitContainer}>
            {/* Center Top Spark Node - FIXED (Does not rotate) */}
            <div className={styles.centerNode}>
              <div className={styles.centerGlow}></div>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2l2.4 4.9 5.3.8-3.8 3.7.9 5.3-4.8-2.5-4.8 2.5.9-5.3-3.8-3.7 5.3-.8L12 2z" fill="white" />
              </svg>
            </div>

            {/* Inner Orbit Line (concentric ring) - ROTATES */}
            <div className={styles.orbitRing1}>
              {/* HubSpot */}
              <div className={`${styles.toolCard} ${styles.hubspot}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>HubSpot</span>
              </div>

              {/* Slack */}
              <div className={`${styles.toolCard} ${styles.slack}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>Slack</span>
              </div>
            </div>

            {/* Outer Orbit Line (concentric ring) - ROTATES */}
            <div className={styles.orbitRing2}>
              {/* Salesforce */}
              <div className={`${styles.toolCard} ${styles.salesforce}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>Salesforce</span>
              </div>

              {/* Zapier */}
              <div className={`${styles.toolCard} ${styles.zapier}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>Zapier</span>
              </div>

              {/* Gmail */}
              <div className={`${styles.toolCard} ${styles.gmail}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>Gmail</span>
              </div>

              {/* Calendar */}
              <div className={`${styles.toolCard} ${styles.calendar}`}>
                <div className={styles.iconBox}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" fill="currentColor" />
                  </svg>
                </div>
                <span className={styles.toolLabel}>Calendar</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Setup Steps Section */}
      <section className={styles.effortlessSection}>
        <div className={styles.container}>
          <h2 className={styles.title}>
            Effortless setup in <span className={styles.gradientText}>three simple steps.</span>
          </h2>

          <div className={styles.cards}>
            {steps.map((step, index) => (
              <div key={index} className={styles.card}>
                <div className={styles.stepNumIcon}>
                  {index === 0 && "🤖"}
                  {index === 1 && "🔗"}
                  {index === 2 && "⚡"}
                </div>
                <div className={styles.cardStepTag}>{step.tag}</div>
                <h3 className={styles.cardTitle}>{step.title}</h3>
                <p className={styles.cardDesc}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ready to Scale Section (Large Gradient Card) */}
      <section className={styles.scaleSection}>
        <div className={styles.container}>
          <div className={styles.scaleCard}>
            <div className={styles.scaleLeft}>
              <h2 className={styles.scaleTitle}>
                Ready to scale beyond <br />
                10,000+ minutes a month?
              </h2>
              <ul className={styles.scaleList}>
                <li>
                  <span className={styles.checkIcon}>✓</span>
                  No per-seat pricing
                </li>
                <li>
                  <span className={styles.checkIcon}>✓</span>
                  Unlimited concurrent calls
                </li>
                <li>
                  <span className={styles.checkIcon}>✓</span>
                  Dedicated success manager
                </li>
              </ul>
              <button className={styles.talkSalesBtn} onClick={() => navigate("/demo-form")}>
                Talk to sales <span className={styles.btnArrow}>→</span>
              </button>
            </div>

            <div className={styles.scaleRight}>
              <div className={styles.outerCircle}>
                <div className={styles.innerCircle}>
                  <h3 className={styles.twentyFourSeven}>24/7</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LandingPageSection6;
